module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-4"
  }, [_c('v-card-title', {
    staticClass: "overline my-0 py-0 grey lighten-3"
  }, [(_vm.practitioner) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.practitioner.full_name)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.space) ? _c('span', {
    staticClass: "ml-1"
  }, [_vm._v("@ " + _vm._s(_vm.space.title))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', _vm._l((_vm.dow), function(day, index) {
    return (_vm.hours) ? _c('v-card', {
      key: index,
      staticClass: "ma-3 elevation-4",
      attrs: {
        "tile": ""
      }
    }, [_c('v-card-title', {
      staticClass: "grey lighten-2 overline py-1 my-0"
    }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('v-list', {
      staticClass: "elevation-0 pa-0",
      attrs: {
        "dense": ""
      }
    }, [_c('v-divider'), _vm._v(" "), _vm._l((_vm.getHours(index)), function(hrSet) {
      return (hrSet !== "" && _vm.hours[_vm.dowLookup[index]]) ? _c('v-list-tile', {
        key: hrSet
      }, [_c('v-list-tile-content', {
        on: {
          "click": function($event) {
            return _vm.setHours(_vm.dowLookup[index], hrSet)
          }
        }
      }, [_c('v-list-tile-title', [_c('v-icon', {
        staticClass: "mr-2"
      }, [_vm._v("edit")]), _vm._v(" " + _vm._s(hrSet) + "\n            ")], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
        attrs: {
          "icon": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteHours(_vm.dowLookup[index], hrSet)
          }
        }
      }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)], 1) : _c('v-list-tile', {
        key: index
      }, [_c('v-list-tile-content', [_vm._v("\n            Not available for appointments\n          ")])], 1)
    }), _vm._v(" "), _c('v-layout', [_c('v-flex', {
      staticClass: "text-xs-right"
    }, [_c('v-btn', {
      attrs: {
        "flat": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.showAddHours(_vm.dowLookup[index])
        }
      }
    }, [_c('v-icon', [_vm._v("add")]), _vm._v("Add hours")], 1)], 1)], 1)], 2)], 1) : _vm._e()
  }), 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "auto-save",
      "dense": "",
      "small": ""
    },
    model: {
      value: (_vm.autosave),
      callback: function($$v) {
        _vm.autosave = $$v
      },
      expression: "autosave"
    }
  }), _vm._v(" "), (!_vm.autosave) ? _c('v-btn', {
    attrs: {
      "loading": _vm.servicesSaveHrsRequest.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.saveHours
    }
  }, [_vm._v("Save")]) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300px"
    },
    model: {
      value: (_vm.rangePickerDialog),
      callback: function($$v) {
        _vm.rangePickerDialog = $$v
      },
      expression: "rangePickerDialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('time-range-picker', {
    attrs: {
      "min-start-time": _vm.minStartTime,
      "initial-start-time": _vm.activeStartTime,
      "initial-end-time": _vm.activeEndTime
    },
    model: {
      value: (_vm.activeRange),
      callback: function($$v) {
        _vm.activeRange = $$v
      },
      expression: "activeRange"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.rangePickerDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.editmode) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.activeRange
    },
    on: {
      "click": function($event) {
        return _vm.editHours(_vm.activeDay, _vm.originalEditRange, _vm.activeRange)
      }
    }
  }, [_vm._v("Edit")]) : _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.activeRange
    },
    on: {
      "click": function($event) {
        return _vm.addHours(_vm.activeDay, _vm.activeRange)
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dfd7dd1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/locations/OperatingHours.vue
// module id = 1370
// module chunks = 9